import { render, staticRenderFns } from "./PurchasePaymentConfirm.vue?vue&type=template&id=13d4a8b9"
import script from "./PurchasePaymentConfirm.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports